module.exports = __webpack_public_path__ + "static/img/mark7.b0e4688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/markdown/mark7.png
// module id = BCGC
// module chunks = 0